import classNames from "classnames";
import React from "react";
import { RiArrowDropDownLine } from "react-icons/ri";

const ProviderItem = ({
  provider,
  selectedProvider,
  providerColors,
  handleProvider,
  children,
}) => {
  const isOpen = selectedProvider === provider.id;

  return (
    <div className="flex flex-col max-h-96">
      <button
        onClick={() => handleProvider(provider.id)}
        className="flex flex-row items-center justify-between border-primarygrayborder"
      >
        <div className="flex flex-row items-center w-full gap-2">
          <div
            className="w-4 h-4 rounded-full"
            style={{
              backgroundColor: providerColors[provider.id],
            }}
          />
          <span
            className={classNames(
              "m-0 text-xl font-semibold text-left",
              isOpen && "text-primaryblue"
            )}
          >
            {provider.name}{" "}
            <span
              className="m-0"
              style={{
                color: providerColors[provider.id],
              }}
            >
              ({provider.count})
            </span>
          </span>
          <RiArrowDropDownLine
            size={40}
            className={classNames(
              "ml-auto transition-all ease-in-out duration-300",
              isOpen ? "text-primaryblue rotate-0" : "-rotate-90"
            )}
          />
        </div>
      </button>
      <div
        className={classNames(
          "flex flex-col overflow-hidden transition-all duration-300 bg-slate-50 pb-2 border rounded-md p-1 no-scrollbar",
          isOpen ? "max-h-[800px] opacity-100" : "max-h-0 opacity-0"
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default ProviderItem;
